const currencyFormatters = new Map<string, Intl.NumberFormat>();

const getCurrencyFormatter = (currency: string) => {
  let formatter = currencyFormatters.get(currency);
  if (!formatter) {
    formatter = new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    });
    currencyFormatters.set(currency, formatter);
  }
  return formatter;
};

export const formatCurrency = (
  amount: number | null | undefined,
  currency: string = "RUB",
): string => {
  if (amount === null || amount === undefined || Number.isNaN(amount)) {
    return getCurrencyFormatter(currency).format(0);
  }
  return getCurrencyFormatter(currency).format(amount);
};
